/**
 * Type: ページ
 * What: STUDIO E・ZO
 */
import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { scroller } from 'react-scroll';
import Layout from '../components/Layout';
import SEO from '../components/Seo';
import BreadcrumbComponent from '../components/Breadcrumb';
import SimpleSwiper from '../components/Slider.fade';
import Image from '../util/Image';
import PostListComponent from '../components/PostList/PostList.obm';
import { Button } from '../components/Btn';

const pageTitle = 'STUDIO E・ZO（スタジオイーゾ）';
const pageDescription = 'ミュージアム内には放送スタジオ「スタジオE・ZO」を設置。ホークス戦ダイジェスト番組収録など計画しております。';
const pageSlug = 'obm';
const pageLogo = 'studio-logo.jpg';

const sliderDataobj = [
  {
    filename: 'main-studio.jpg',
  },
];

// Data Props Template
const Template = () => {
  const scrollToTarget = (e, elem, offset) => {
    e.preventDefault();
    const $offset = offset || -110;
    scroller.scrollTo(elem, {
      duration: 1200,
      delay: 0,
      offset: $offset,
      smooth: 'easeOutQuint',
    });
  };
  const data = useStaticQuery(graphql`
    {
      allWordpressAcfPages(filter: {wordpress_id: {eq: 3}}) {
        nodes {
          acf {
            pdf {
              source_url
            }
          }
        }
      }
    }
  `);
  const post = data.allWordpressAcfPages.nodes;
  const pdfUrl = post[0].acf.pdf.source_url;
  return (
    <Layout pageSlug={pageSlug} bg="bg-4">
      <SEO
        title={pageTitle}
        description={pageDescription}
      />
      <BreadcrumbComponent
        hierarchy={3}
        bread2url="obm/"
        bread2title="ヒストリーゾーン・89パーク・STUDIO E・ZO"
        bread3title={pageTitle}
      />
      <section className="pageMain bg-12 bs-4 no-border">
        <div className="kv-wrap bg-4">
          <div className="kv-inner">
            <SimpleSwiper data={sliderDataobj} />
          </div>
          <div className="container">
            <div className="inner">
              <div className="pageMain-header">
                <div className="floorNo c-4">
                  <span>4</span>
                  <span>F</span>
                </div>
                <h3 className="ttl">
                  <span className="logo-under">
                    <Image src={pageLogo} alt={pageTitle} />
                    {/* <span>
                      <b className="is-1">{pageTitle}</b>
                    </span> */}
                  </span>
                </h3>
              </div>
              <div className="overview">
                <p className="text c-4">
                  ホークス戦ダイジェスト番組収録など魅力的な情報をスタジオからお届けします。
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="section-link">
          <ul>
            {/*
            <li>
              <a
                href="#topics"
                onClick={(e) => scrollToTarget(e, 'topics', -68)}
              >
                <span
                  className="arrow"
                >
                  TOPICS
                </span>
              </a>
            </li>
            */}
            <li>
              <a
                href="#program"
                onClick={(e) => scrollToTarget(e, 'program')}
              >
                <span
                  className="arrow"
                >
                  収録番組のご案内
                </span>
              </a>
            </li>

          </ul>
        </div>
      </section>
      <PostListComponent />
      <section className="section sc-museum bg-12" id="program">
        <div className="container">
          <div className="inner">
            <h3 className="headline">
              <span>収録番組のご案内</span>
            </h3>
            <div className="sc-columns">
              <div
                className="col col-6 floorbc"
                data-sal="slide-up"
                data-sal-easing="ease-out-expo"
              >
                <a
                  href="https://www.softbankhawks.co.jp/news/detail/00003389.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="col-inner">
                    <div className="col-image">
                      <figure className="image">
                        <Image filename="img-studio-program-mikata.jpg" />
                      </figure>
                    </div>
                    <div className="col-content bg-12">
                      <h3 className="ttl c-4 has-text-align-left">鷹のミカタ</h3>
                    </div>
                  </div>
                </a>
              </div>
              <div
                className="col col-6 floorbc"
                data-sal="slide-up"
                data-sal-easing="ease-out-expo"
              >
                <a
                  href="https://www.softbankhawks.co.jp/news/detail/00003389.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="col-inner">
                    <div className="col-image">
                      <figure className="image">
                        <Image filename="img-studio-program-hawks.jpg" />
                      </figure>
                    </div>
                    <div className="col-content bg-12">
                      <h3 className="ttl c-4 has-text-align-left">熱血宣言！E・ZO HAWKS</h3>
                    </div>
                  </div>
                </a>
              </div>

            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Template;
